// traits: kind, devoted, joyful, loyal, proud, wise, calm, fierce, cunning
const T = ["kind", "devoted", "joyful", "loyal", "proud", "wise", "calm", "fierce", "cunning"];
const v = (o) => T.map((t) => o[t] ?? 0);
const rep = (colors) => Array.from({ length: 18 }, (_, i) => colors[i % colors.length]);

const BANK = [
  ["A stranger needs help at midnight. You…", [
    ["Help, even if it costs you everything", { kind: 2, devoted: 1 }],
    ["Protect them fiercely, no questions asked", { fierce: 2, devoted: 1 }],
    ["Bring snacks and make them laugh", { joyful: 2, kind: 1 }],
    ["Grumble, then help anyway", { loyal: 1, proud: 1, fierce: 1 }],
    ["Quietly figure out who sent them", { cunning: 2, calm: 1 }],
  ]],
  ["Where does your heart feel at home?", [
    ["A quiet little shrine", { calm: 2, kind: 1 }],
    ["A city glowing with lanterns", { devoted: 1, cunning: 1, joyful: 1 }],
    ["The wide open sky", { joyful: 2 }],
    ["Training grounds at dawn", { fierce: 2, loyal: 1 }],
    ["A library full of old scrolls", { wise: 2, calm: 1 }],
  ]],
  ["How do you show love?", [
    ["Small, gentle kindnesses", { kind: 2 }],
    ["Devotion that lasts lifetimes", { devoted: 3 }],
    ["Being a loyal, joyful friend", { loyal: 2, joyful: 1 }],
    ["Standing guard, always", { loyal: 1, fierce: 1, devoted: 1 }],
    ["Grand gifts and grand gestures", { proud: 2, devoted: 1 }],
  ]],
  ["Someone wrongs you. You…", [
    ["Forgive them and move on", { kind: 2, calm: 1 }],
    ["Wait patiently. You never forget", { cunning: 2, calm: 1, fierce: 1 }],
    ["Fight them right now", { fierce: 2 }],
    ["Prove them wrong by being better", { proud: 2, wise: 1 }],
  ]],
  ["Your friends would call you…", [
    ["Wise beyond your years", { wise: 2 }],
    ["Dramatic and fun", { joyful: 2 }],
    ["Totally dependable", { loyal: 2 }],
    ["Mysterious", { cunning: 1, calm: 2 }],
    ["Ambitious", { proud: 2 }],
  ]],
  ["Which treasure would you keep?", [
    ["A note someone wrote just for you", { kind: 1, devoted: 1 }],
    ["A sharp, trusty sword", { fierce: 2, proud: 1 }],
    ["A beautiful folding fan", { joyful: 2 }],
    ["An ancient scroll of secrets", { wise: 2, cunning: 1 }],
    ["A silver butterfly charm", { devoted: 2, cunning: 1 }],
  ]],
  ["At a heavenly banquet, you…", [
    ["Sit quietly in a corner", { calm: 2, kind: 1 }],
    ["Organize everything behind the scenes", { wise: 1, cunning: 1, proud: 1 }],
    ["Dance, gossip and make new friends", { joyful: 2 }],
    ["Only have eyes for one person", { devoted: 2, cunning: 1 }],
    ["Leave early to go train", { fierce: 1, proud: 1, loyal: 1 }],
  ]],
  ["Pick a weapon:", [
    ["A trusty sword", { fierce: 2, loyal: 1 }],
    ["A bow and arrows", { fierce: 1, calm: 1, loyal: 1 }],
    ["A folding fan", { joyful: 2 }],
    ["A scimitar with a watchful eye", { devoted: 2, fierce: 1 }],
    ["A silk ribbon that moves on its own", { kind: 2, calm: 1 }],
  ]],
  ["Your perfect day off:", [
    ["Collecting odds and ends, then cooking (badly)", { kind: 2, joyful: 1 }],
    ["Reading in a quiet library", { wise: 2, calm: 1 }],
    ["Sparring until sunset", { fierce: 2 }],
    ["Drinking and laughing with friends", { joyful: 2, loyal: 1 }],
    ["Making secret plans", { cunning: 2, wise: 1 }],
  ]],
  ["Which element calls to you?", [
    ["Wind", { joyful: 2 }],
    ["Deep water", { cunning: 2, calm: 1 }],
    ["Fire", { fierce: 2 }],
    ["Earth", { loyal: 2, calm: 1 }],
    ["Moonlight", { calm: 2, kind: 1 }],
  ]],
  ["Your biggest flaw?", [
    ["Too trusting", { kind: 2 }],
    ["Too stubborn", { loyal: 1, fierce: 1, proud: 1 }],
    ["Too proud", { proud: 2 }],
    ["Too secretive", { cunning: 2, calm: 1 }],
    ["Too loud", { joyful: 2, fierce: 1 }],
  ]],
  ["Someone you love is in danger. You…", [
    ["Walk through fire for them", { devoted: 2, fierce: 1 }],
    ["Make a clever plan", { wise: 1, cunning: 2 }],
    ["Call every friend you have", { joyful: 1, loyal: 2 }],
    ["Take their place", { kind: 2, devoted: 1 }],
  ]],
  ["A gift for your crush:", [
    ["A thousand floating lanterns", { devoted: 3 }],
    ["Something you made by hand", { kind: 2 }],
    ["A poem", { wise: 2 }],
    ["A dazzling jewel", { proud: 2 }],
    ["A harmless prank", { joyful: 1, cunning: 1 }],
  ]],
  ["Pick a color:", [
    ["Crimson red", { devoted: 2, fierce: 1 }],
    ["Pure white", { kind: 2, calm: 1 }],
    ["Ink black", { cunning: 2, calm: 1 }],
    ["Gold", { proud: 2 }],
    ["Sky blue", { joyful: 1, wise: 1 }],
    ["Lantern green", { joyful: 1, fierce: 1, cunning: 1 }],
  ]],
  ["When you fail, you…", [
    ["Laugh and try again", { kind: 1, joyful: 2 }],
    ["Train twice as hard", { fierce: 1, loyal: 1, proud: 1 }],
    ["Never let anyone see", { proud: 2, cunning: 1 }],
    ["Reflect quietly", { wise: 2, calm: 1 }],
  ]],
  ["At the Ghost Market, you buy…", [
    ["A mysterious mask", { cunning: 2 }],
    ["A cursed blade", { fierce: 2 }],
    ["Ancient scrolls", { wise: 2 }],
    ["Snacks for everyone", { joyful: 1, kind: 1 }],
    ["Nothing. You came for someone", { devoted: 2 }],
  ]],
  ["Your role in a team:", [
    ["The leader", { proud: 2, wise: 1 }],
    ["The protector", { loyal: 2, fierce: 1 }],
    ["The heart", { kind: 2, joyful: 1 }],
    ["The strategist", { cunning: 1, wise: 2 }],
    ["The wild card", { joyful: 1, fierce: 1, cunning: 1 }],
  ]],
  ["Where would you wait for someone?", [
    ["On temple steps, for eight hundred years", { devoted: 3 }],
    ["Under a tree, half asleep", { calm: 2 }],
    ["In a busy tavern", { joyful: 2 }],
    ["On a rooftop, watching quietly", { cunning: 1, loyal: 1, calm: 1 }],
  ]],
  ["What do people misunderstand about you?", [
    ["I'm tougher than I look", { kind: 1, fierce: 1, loyal: 1 }],
    ["I'm softer than I look", { kind: 1, proud: 1, loyal: 1 }],
    ["I'm smarter than I act", { joyful: 1, wise: 2 }],
    ["I'm not as calm as I seem", { calm: 1, devoted: 1, cunning: 1 }],
  ]],
  ["Pick a motto:", [
    ["Body in the abyss, heart in paradise", { kind: 2, calm: 1 }],
    ["For you, anything", { devoted: 3 }],
    ["Friends first, always", { loyal: 1, joyful: 2 }],
    ["Strength speaks louder", { fierce: 2, proud: 1 }],
    ["Patience wins everything", { cunning: 2, calm: 1 }],
  ]],
  ["Choose a creature:", [
    ["Silver butterflies", { devoted: 2, cunning: 1 }],
    ["A loyal dog", { loyal: 2 }],
    ["A graceful crane", { wise: 2, calm: 1 }],
    ["A clever fox", { cunning: 2, joyful: 1 }],
    ["A tiger", { fierce: 2, proud: 1 }],
  ]],
].map(([q, answers]) => [q, answers.map(([text, traits]) => [text, v(traits)])]);

export const QUIZ_LENGTH = 7;
export const BANK_SIZE = BANK.length;

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const pickQuestions = () => shuffle(BANK).slice(0, QUIZ_LENGTH).map(([q, answers]) => [q, shuffle(answers)]);

export const CHARACTERS = [
  { name: "Xie Lian", title: "The Crown Prince of Xianle", text: "Kind to the core, you keep smiling through every fall and still reach out to help others.",
    traits: v({ kind: 3, devoted: 1, joyful: 1, loyal: 1, wise: 1, calm: 2 }), beads: rep(["#f2f0ea", "#fff8e7", "#e6ccff"]) },
  { name: "Hua Cheng", title: "Crimson Rain Sought Flower", text: "Devoted and fearless. Once you choose someone, you will wait for them forever.",
    traits: v({ devoted: 3, loyal: 1, fierce: 2, cunning: 2 }), beads: rep(["#c1121f", "#1b1b1f", "#c1121f"]), image: "/img/tg/hua-cheng.jpg" },
  { name: "Shi Qingxuan", title: "The Wind Master", text: "Bright, generous and a little chaotic, you turn strangers into friends in a breath.",
    traits: v({ kind: 1, joyful: 3, loyal: 2 }), beads: rep(["#a0d2ff", "#8fe3cf", "#f2f0ea"]) },
  { name: "Feng Xin", title: "General Nan Yang", text: "Blunt and stubborn, but loyal to the bone. You show up for the people you love.",
    traits: v({ loyal: 3, proud: 1, fierce: 2 }), beads: rep(["#e9b949", "#2b2d6e", "#ffd166"]) },
  { name: "Mu Qing", title: "General Xuan Zhen", text: "Proud, sharp-tongued and hardworking. You care more than you'll ever admit.",
    traits: v({ loyal: 1, proud: 3, wise: 1, calm: 1, cunning: 1 }), beads: rep(["#2b2d6e", "#1b1b1f", "#f2f0ea"]) },
  { name: "Mei Nianqing", title: "The State Preceptor of Xianle", text: "A wise old soul with a mischievous streak. You see further than everyone else.",
    traits: v({ joyful: 1, wise: 3, calm: 1, cunning: 2 }), beads: rep(["#7b2cbf", "#e9b949", "#f2f0ea"]), image: "/img/tg/mei-nianqing.jpg" },
  { name: "Yin Yu", title: "Keeper of Ghost City's affairs", text: "Quiet, steady and gentle. You carry old hurts with grace and keep everything running.",
    traits: v({ kind: 1, loyal: 2, calm: 3 }), beads: rep(["#6b5b5b", "#f2f0ea", "#2a9d8f"]), image: "/img/tg/yin-yu.jpg" },
  { name: "He Xuan", title: "Black Water Sinking Ships", text: "Calm as deep water and twice as patient. Nothing slips past you.",
    traits: v({ calm: 2, fierce: 1, cunning: 3 }), beads: rep(["#1b1b1f", "#2b2d6e", "#3a86ff"]) },
  { name: "Shi Wudu", title: "The Water Master", text: "Powerful and proud, you would move heaven itself to protect your family.",
    traits: v({ devoted: 2, proud: 2, cunning: 2 }), beads: rep(["#3a86ff", "#2a9d8f", "#f2f0ea"]) },
  { name: "Lang Qianqiu", title: "General Tai Hua", text: "Earnest, honest and brave. You say what you mean and fight for what's right.",
    traits: v({ kind: 2, joyful: 1, loyal: 1, fierce: 2 }), beads: rep(["#ffd166", "#f7b2c8", "#f2f0ea"]) },
  { name: "Ling Wen", title: "Ling Wen, God of Literature", text: "Organized, clever and unshakably composed. You keep heaven's paperwork and its secrets.",
    traits: v({ loyal: 1, wise: 2, calm: 2, cunning: 2 }), beads: rep(["#6a2c70", "#f2f0ea", "#1b1b1f"]) },
  { name: "Pei Ming", title: "General Ming Guang", text: "Confident, charming and a little too pleased with yourself. People can't help noticing you.",
    traits: v({ joyful: 2, proud: 3, fierce: 1 }), beads: rep(["#e9b949", "#6b5b5b", "#ffd6e0"]) },
  { name: "Quan Yizhen", title: "Qi Ying, Martial God of the West", text: "Pure fighting spirit. You're straightforward, tireless and stronger than anyone expects.",
    traits: v({ joyful: 1, fierce: 3 }), beads: rep(["#ff6f61", "#ffd166", "#e9b949"]) },
  { name: "Jun Wu", title: "The Heavenly Emperor", text: "Composed and commanding. You see the whole board and rarely show your hand.",
    traits: v({ kind: 1, proud: 2, wise: 2, calm: 2, cunning: 1 }), beads: rep(["#fff8e7", "#e9b949", "#f2f0ea"]), image: "/img/tg/jun-wu.jpg" },
  { name: "Qi Rong", title: "Green Lantern Night Wanderer", text: "Loud, wild and impossible to ignore. Chaos follows you everywhere you go.",
    traits: v({ joyful: 2, proud: 1, fierce: 2, cunning: 2 }), beads: rep(["#2d6a4f", "#b8f2a8", "#1b1b1f"]), image: "/img/tg/qi-rong.jpg" },
  { name: "Banyue", title: "The State Preceptor of Banyue", text: "Soft-hearted and loyal. You protect those you love, even when it's hard.",
    traits: v({ kind: 3, devoted: 1, loyal: 2 }), beads: rep(["#f7b2c8", "#c8a2ff", "#ffd6e0"]) },
];

const norm = (a) => Math.sqrt(a.reduce((s, x) => s + x * x, 0)) || 1;

export const matchCharacter = (answerVectors) => {
  const total = T.map((_, i) => answerVectors.reduce((s, a) => s + a[i], 0));
  const scored = CHARACTERS.map((c) => [c, c.traits.reduce((s, x, i) => s + x * total[i], 0) / norm(c.traits)]);
  const best = Math.max(...scored.map(([, s]) => s));
  const top = scored.filter(([, s]) => s >= best - 1e-9).map(([c]) => c);
  return top[Math.floor(Math.random() * top.length)];
};
